var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.displayNumber(_vm.costsCounter, 0, _vm.unit)))])}
var staticRenderFns = []

export { render, staticRenderFns }